import { Job } from '../types/job';

const workExperience: Job[] = [
  {
    title: 'Software Engineering Resident',
    company: 'Galvanize',
    startDate: 'May 2022',
    endDate: 'Present',
    description: ['After my graduation from Hack Reactor, I was asked to stay with the program in a teaching capacity as an Engineering Resident.'],
    bulletPoints: ['Instructed 60+ students in CS fundamentals and JS core concepts, and modern web dev technologies', 'Supported student progress by providing in-depth code review feedback and 1-on-1 mentoring sessions', 'Collaborated with students to improve their debugging and problem-solving skills'],
  },
  {
    title: 'Engineering Immersive',
    company: 'Hack Reactor',
    startDate: 'February 2022',
    endDate: 'May 2022',
    description: ['To accelerate my career change into software engineering, I attended Hack Reactor\'s 12-week immersive program, where I became comfortable with the MERN stack.'],
    bulletPoints: [],
  },
  {
    title: 'Senior Manager',
    company: 'SponsorUnited',
    startDate: 'October 2019',
    endDate: 'February 2022',
    description: ['I joined SponsorUnited as an intern in college, and just over a year later I was promoted to the highest position within the operations department.'],
    bulletPoints: ['Managed a team of 15+ members across the West Coast', 'Organized 100+ data-collection projects', 'Assisted in leading a company-wide training program'],
  },
];

export default workExperience;